import React from "react";
import { useNavigate } from "react-router-dom";


const MainPage = () => {
     const navigate = useNavigate();
  return (
    <div className="main-container">
      <div className="hero-content">
        <h1 className="hero-title">
          Your Journey Starts Here
          <span> Build Your Career with Red Cloud</span>
        </h1>
        <p className="hero-subtitle">
          A unified HR platform to manage people, roles, and productivity.
        </p>

        <div className="card-wrapper mt-3">
          <div className="card">
            <h2>Access Your Account</h2>
            <p>
              Already part of <strong>Red Cloud</strong>?  
              Sign in and continue your journey.
            </p>
            <button onClick={() => navigate("/login")} className="primary-btn mt-3">Login </button>
          </div>

          <div className="card outline">
            <h2>Create Your Account</h2>
            <p>
              New here? Start your experience and manage people effectively.
            </p>
            <button onClick={() => navigate("/register")} className="secondary-btn mt-3">Register</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainPage;
